import { FormFieldRowInputType } from './form-field-row.type';

/** Shared by the desktop inline editor and the mobile sheet so their defaults cannot drift. */
export const DEFAULT_AVAILABLE_TYPES: readonly FormFieldRowInputType[] = ['text', 'number'];
